import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http'
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es-MX';
registerLocaleData(localeEs);

// Ionic native- providers
import { IonicStorageModule } from '@ionic/storage';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { Geolocation } from '@ionic-native/geolocation';

//Pipes - declarations, entry components
import { ShortenPipe } from './../pipes/shorten';
import { TCasePipe } from './../pipes/t-case';
import { TranslatePipe } from './../pipes/translate';
import { TimezonePipe } from './../pipes/timezone';
import { FpCurrencyPipe } from '../pipes/fp-currency';


//Modules- imports
import { AuthModule } from './../pages/auth/auth.module';
//npm-modules - imports
// import { NgCircleProgressModule } from 'ng-circle-progress';

//Components- declarations, entry components
import { MyApp } from './app.component';
import { ImageCarouselComponent } from './../components/image-carousel/image-carousel';
import { MapComponent } from './../components/map/map.component';
import {MapboxMapComponent} from '../components/mapbox-map/mapbox-map.component';
import { SmallMapComponent } from '../components/small-map/small-map';
import { StaticMapComponent } from '../components/static-map/static-map';
import { DateSelectorComponent } from './../components/date-selector/date-selector';
import { FaIconComponent } from './../components/fa-icon/fa-icon';
import { GymServicesComponent } from './../components/gym-services/gym-services';
import { SummaryHeaderComponent } from './../components/summary-header/summary-header';
import { ClassListItemComponent } from './../components/class-list-item/class-list-item';
import { StudioListItemComponent } from './../components/studio-list-item/studio-list-item';
import { MyClassListItemComponent } from './../components/my-class-list-item/my-class-list-item';

//Pages- declarations, entry components
/*-*/import { TabsPage } from './../pages/tabs/tabs';
/*--*/import { HomePage } from '../pages/tabs/home/home'
/*--*/import { FindClassPage } from '../pages/tabs/find-class/find-class';
/*---*/import { FiltersPage } from './../pages/tabs/find-class/filters/filters';
/*---*/import { SearchBarPage } from './../pages/tabs/find-class/search-bar/search-bar';
/*--*/import { MyClassesPage } from './../pages/tabs/my-classes/my-classes';
/*---*/import { AchievementsComponent } from './../pages/tabs/my-classes/achievements/achievements';
/*----*/import { AchievementPage } from './../pages/tabs/my-classes/achievements/achievement/achievement';
/*--*/import { ProfilePage } from './../pages/tabs/profile/profile';
/*---*/import { PaymentHistoryPage } from './../pages/tabs/profile/payment-history/payment-history';
/*---*/import { AccountPage } from './../pages/tabs/profile/account/account';
/*---*/import { MembershipPage } from './../pages/tabs/profile/membership/membership';
/*----*/import { NewMembershipPage } from './../pages/tabs/profile/membership/new-membership/new-membership';
/*----*/import { UpdateMembershipPage } from './../pages/tabs/profile/membership/update-membership/update-membership';
/*---*/import { ReferralPage } from './../pages/tabs/profile/referral/referral';
/*---*/import { GymsPage } from '../pages/tabs/profile/gyms/gyms';

/*--*//*shared*/
/*---*/import { ClassPage } from './../pages/tabs/shared/class/class';
/*----*/import { ConfirmPage } from './../pages/tabs/shared/class/confirm/confirm';
/*----.*/import { ExtraClassPage } from './../pages/tabs/shared/class/confirm/extra-class/extra-class';
/*----*/import { CancelPage } from './../pages/tabs/shared/class/cancel/cancel';
/*---*/import { StudioPage } from './../pages/tabs/shared/studio/studio';
/*---*/import { ReviewPage } from './../pages/tabs/shared/review/review';
/*---*/import { CameraPage } from './../pages/tabs/shared/camera/camera';

//Services- providers
import { PlatformService } from './../services/platform';
import { SessionService } from './../services/session';
import { AuthService } from './../services/auth';
import { StudiosService } from './../services/studios';
import { MapService } from './../services/map';
import { BeautyMapService } from './../services/beauty-map';
import { AnalyticsService } from './../services/analytics';
import { ClassesService } from './../services/classes';
import { ReservationsService } from './../services/reservations'
import { PWAPushService } from './../services/notifications/pwa-push';
import {FiltersService} from './../services/filters';
import { MembershipService } from './../pages/tabs/profile/membership/membership.service';
import { LocationsService } from './../services/locations';
import { FirebaseService } from './../services/firebase'
import { BackendModule } from '../modules/backend.module';
import { TabsService } from './../pages/tabs/tabs.service';
import { AchievementsService } from './../services/achievements';
import { VersionService } from './../services/version';
import { MishiService } from './../services/mishi';

//Directives- declarations, entry components
import { FocuserDirective } from './../directives/focuser/focuser'
import { DropFileDirective } from './../directives/drop-file/drop-file';
import { PickFileDirective } from './../directives/drop-file/pick-file';
import {BeautyPage} from '../pages/tabs/beauty/beauty';
import {FindBeautyClassPage} from '../pages/tabs/beauty/find-beauty-class/find-beauty-class';
import {SearchBeautyBarPage} from '../pages/tabs/beauty/find-beauty-class/search-bar/search-bar';
import {BeautyIntroduction} from '../pages/tabs/beauty/find-beauty-class/introduction/introduction';
import {BeautyClassesService} from '../services/beauty-classes';
import {MyBeautyClassesPage} from '../pages/tabs/beauty/my-beauty-classes/my-beauty-classes';
import {BeautyClassPage} from '../pages/tabs/shared/beauty-class/beauty-class';
import {BeautyStudioPage} from '../pages/tabs/shared/beauty-studio/beauty-studio';
import {BeautyConfirmPage} from '../pages/tabs/shared/beauty-class/beauty-confirm/beauty-confirm';
import {BeautyFiltersPage} from '../pages/tabs/beauty/find-beauty-class/beauty-filters/beauty-filters';
import {BeautyMapComponent} from '../components/beauty-map/beauty-map.component';
import {BeautyStudiosService} from '../services/beauty-studios';
import {BeautySummaryHeaderComponent} from '../components/beauty-summary-header/beauty-summary-header';
import {BeautyFiltersService} from '../services/beauty-filters';
import {MyBeautyClassListItemComponent} from '../components/my-beauty-class-list-item/my-beauty-class-list-item';
import {ComplementsPage} from '../pages/tabs/profile/membership/complements';
import {NewComplementPage} from '../pages/tabs/profile/membership/new-complement/new-complement';
import {BeautyCancelPage} from '../pages/tabs/shared/beauty-class/beauty-cancel/beauty-cancel';
import {
  BeautyExtraClassPage
} from '../pages/tabs/shared/beauty-class/beauty-confirm/beauty-extra-class/beauty-extra-class';
import {BeautyReviewPage} from '../pages/tabs/shared/beauty-review/beauty-review';

@NgModule({
  declarations: [
    MyApp,
    TabsPage,
    HomePage,
    BeautyPage,
    BeautyIntroduction,
    FindClassPage,
    FindBeautyClassPage,
    FiltersPage,
    BeautyFiltersPage,
    SearchBarPage,
    SearchBeautyBarPage,
    MyClassesPage,
    MyBeautyClassesPage,
    ProfilePage,
    PaymentHistoryPage,
    AchievementsComponent,
    AchievementPage,
    AccountPage,
    ComplementsPage,
    MembershipPage,
    NewMembershipPage,
    NewComplementPage,
    UpdateMembershipPage,
    ReferralPage,
    GymsPage,
    StudioPage,
    ClassPage,
    BeautyStudioPage,
    BeautyClassPage,
    ConfirmPage,
    BeautyConfirmPage,
    BeautyCancelPage,
    ExtraClassPage,
    BeautyExtraClassPage,
    CancelPage,
    ReviewPage,
    BeautyReviewPage,
    CameraPage,
    ImageCarouselComponent,
    MapComponent,
    MapboxMapComponent,
    BeautyMapComponent,
    SmallMapComponent,
    StaticMapComponent,
    DateSelectorComponent,
    FaIconComponent,
    GymServicesComponent,
    BeautySummaryHeaderComponent,
    SummaryHeaderComponent,
    ClassListItemComponent,
    StudioListItemComponent,
    MyClassListItemComponent,
    MyBeautyClassListItemComponent,
    ShortenPipe,
    TCasePipe,
    TranslatePipe,
    TimezonePipe,
    FpCurrencyPipe,
    FocuserDirective,
    DropFileDirective,
    PickFileDirective
  ],
  imports: [
    BackendModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp, {
      monthShortNames: [
        'Ene',
        'Feb',
        'Mar',
        'Abr',
        'May',
        'Jun',
        'Jul',
        'Ago',
        'Sep',
        'Oct',
        'Nov',
        'Dic'
      ],
      monthNames: [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre'
      ],
      backButtonText: '',
      mode: 'ios'
    }),
    IonicStorageModule.forRoot(),
    AuthModule
    // NgCircleProgressModule.forRoot({
    //     // set defaults here
    //     radius: 100,
    //     outerStrokeWidth: 16,
    //     innerStrokeWidth: 8,
    //     outerStrokeColor: "#32a4e9",
    //     innerStrokeColor: "#3878e8",
    //     animationDuration: 300,
    //     showTitle:false,
    //     showSubtitle: false,
    //     showUnits:false,
    // })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    TabsPage,
    HomePage,
    FindClassPage,
    FindBeautyClassPage,
    BeautyPage,
    BeautyIntroduction,
    FiltersPage,
    BeautyFiltersPage,
    SearchBarPage,
    SearchBeautyBarPage,
    MyClassesPage,
    MyBeautyClassesPage,
    ProfilePage,
    PaymentHistoryPage,
    AchievementsComponent,
    AchievementPage,
    AccountPage,
    ComplementsPage,
    MembershipPage,
    NewMembershipPage,
    NewComplementPage,
    UpdateMembershipPage,
    ReferralPage,
    GymsPage,
    StudioPage,
    BeautyStudioPage,
    ClassPage,
    BeautyClassPage,
    ConfirmPage,
    BeautyConfirmPage,
    BeautyCancelPage,
    ExtraClassPage,
    BeautyExtraClassPage,
    CancelPage,
    ReviewPage,
    BeautyReviewPage,
    CameraPage,
    ImageCarouselComponent,
    MapComponent,
    MapboxMapComponent,
    BeautyMapComponent,
    SmallMapComponent,
    StaticMapComponent,
    DateSelectorComponent,
    FaIconComponent,
    GymServicesComponent,
    SummaryHeaderComponent,
    BeautySummaryHeaderComponent,
    ClassListItemComponent,
    StudioListItemComponent,
    MyBeautyClassListItemComponent,
    MyClassListItemComponent,

  ],
  providers: [
    InAppBrowser,
    Geolocation,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    PlatformService,
    AuthService,
    SessionService,
    StudiosService,
    BeautyStudiosService,
    ClassesService,
    BeautyClassesService,
    ReservationsService,
    MapService,
    BeautyMapService,
    AnalyticsService,
    PWAPushService,
    FiltersService,
    BeautyFiltersService,
    MembershipService,
    LocationsService,
    FirebaseService,
    TabsService,
    AchievementsService,
    VersionService,
    FocuserDirective,
    DropFileDirective,
    PickFileDirective,
    MishiService
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts